import React, { useEffect, useState } from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

import balAIcon from "../../../theme/assets/svg/b_bal_show_a_icon.svg";
import balPIcon from "../../../theme/assets/svg/b_bal_show_p_icon.svg";

import sendIcon from "../../../theme/assets/svg/b_cabinet_wallet_send_icon.svg";
import receiveIcon from "../../../theme/assets/svg/b_cabinet_wallet_receive_icon.svg";
import swapIcon from "../../../theme/assets/svg/b_cabinet_wallet_swap_icon.svg";

import { useDispatch, useSelector } from "react-redux";
import {
    getUserData,
    hideBalance,
    setCabinetWalletReceiveModalStatus,
    setCabinetWalletSendModalStatus
} from "../../../store/cabinet/action";

const formatUsd = (value) => {
    const numberValue = Number(value);

    if (!Number.isFinite(numberValue)) return "0.00";

    return numberValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

const CabinetWalletBalance = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const wallets = useSelector(store => store.cabinet.wallets);
    const userData = useSelector(store => store.cabinet.userData);
    const hideBalanceStarted = useSelector(store => store.cabinet.hideBalanceStarted) || false;

    const [isBalanceShow, setIsBalanceShow] = useState(true);

    const balanceValue = wallets?.total_balance || 0.00;

    const pnlUsd = Number(wallets?.daily_pnl?.pnl_usd || 0);
    const pnlPercent = Number(wallets?.daily_pnl?.pnl_percent || 0);

    const isPnlNegative = pnlUsd < 0 || pnlPercent < 0;
    const isPnlPositive = pnlUsd > 0 || pnlPercent > 0;

    const pnlSign = isPnlPositive ? "+" : isPnlNegative ? "-" : "";

    const balance24hValue = `${pnlSign}$${Math.abs(pnlUsd).toFixed(2)} (${pnlSign}${Math.abs(pnlPercent).toFixed(2)}%)`;

    const balanceToggleHandler = () => {
        if (hideBalanceStarted) return;

        const nextHideBalance = isBalanceShow;

        dispatch(hideBalance({
            hide_balance: nextHideBalance,
        }, () => {
            setIsBalanceShow(!nextHideBalance);
            dispatch(getUserData());
        }));
    };

    useEffect(() => {
        if (userData?.hide_balance === true) {
            setIsBalanceShow(false);
            return;
        }

        if (userData?.hide_balance === false) {
            setIsBalanceShow(true);
        }
    }, [userData?.hide_balance]);

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                <div className={Styles.titleRow}>
                    <div className={Styles.title}>
                        {t("Общий криптобаланс")}
                    </div>

                    <button
                        type="button"
                        className={Styles.showBtn}
                        onClick={balanceToggleHandler}
                        disabled={hideBalanceStarted}
                        aria-label={isBalanceShow ? t("Скрыть баланс") : t("Показать баланс")}
                    >
                        <img
                            src={isBalanceShow ? balPIcon : balAIcon}
                            alt={isBalanceShow ? t("Скрыть баланс") : t("Показать баланс")}
                        />
                    </button>
                </div>

                <div className={`${Styles.balance} ${!isBalanceShow ? Styles.balanceHidden : ""}`}>
                    {isBalanceShow ? `$${formatUsd(balanceValue)}` : "••••••••"}
                </div>

                <div
                    className={`
                        ${Styles.balance24h}
                        ${!isBalanceShow ? Styles.balance24hHidden : ""}
                        ${isBalanceShow && isPnlPositive ? Styles.balance24hPositive : ""}
                        ${isBalanceShow && isPnlNegative ? Styles.balance24hNegative : ""}
                    `}
                >
                    {isBalanceShow ? balance24hValue : "••••••"}{" "}
                    <span>{t("Изменение за 24 часа")}</span>
                </div>

                <div className={Styles.btnsWrap}>
                    <div className={Styles.btnsWrapItem}>
                        <button
                            type="button"
                            className={Styles.walletBtn}
                            onClick={() => {
                                dispatch(setCabinetWalletSendModalStatus(true));
                            }}
                        >
                            <div className={Styles.imgWrap}>
                                <img src={sendIcon} alt={t("Отправить")} />
                            </div>
                        </button>

                        <div className={Styles.walletBtnText}>
                            {t("Отправить")}
                        </div>
                    </div>

                    <div className={Styles.btnsWrapItem}>
                        <button
                            type="button"
                            className={Styles.walletBtn}
                            onClick={() => {
                                dispatch(setCabinetWalletReceiveModalStatus(true));
                            }}
                        >
                            <div className={Styles.imgWrap}>
                                <img src={receiveIcon} alt={t("Получить")} />
                            </div>
                        </button>

                        <div className={Styles.walletBtnText}>
                            {t("Получить")}
                        </div>
                    </div>

                    <div className={Styles.btnsWrapItem}>
                        <button type="button" className={Styles.walletBtn}>
                            <div className={Styles.imgWrap}>
                                <img src={swapIcon} alt={t("Обменять")} />
                            </div>
                        </button>

                        <div className={Styles.walletBtnText}>
                            {t("Обменять")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CabinetWalletBalance;